import { type Config } from 'next-i18n-router/dist/types';

const i18nConfig: Config & { defaultNS: string; fallbackNS: string } = {
  locales: ['en', 'es'],
  defaultLocale: 'en',
  defaultNS: 'common',
  fallbackNS: 'common',
};

export default i18nConfig;
